import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { AppConfiguration } from "config";
import {
  ADD_PROSPECT_APPLICANT,
  ADD_PROSPECT_BUSINESS_ENTITY,
  ADD_PROSPECT_HOME,
  ADD_PROSPECT_REFUND,
  ADD_PROSPECT_VEHICLE,
  ADD_PROSPECT_VIOLATION,
  DELETE_PROSPECT_APPLICANT,
  DELETE_PROSPECT_BUSINESS_ENTITY,
  DELETE_PROSPECT_HOME,
  DELETE_PROSPECT_REFUND,
  DELETE_PROSPECT_VEHICLE,
  DELETE_PROSPECT_VIOLATION,
  GET_CONSENT_INFORMATION_BY_ID,
  GET_PROSPECTS,
  GET_PROSPECT_BY_ID,
  GET_PROSPECT_REFUND_REASONS,
  UPDATE_PROSPECT,
  UPDATE_PROSPECT_APPLICANT,
  UPDATE_PROSPECT_BUSINESS_ENTITY,
  UPDATE_PROSPECT_DETAILS,
  UPDATE_PROSPECT_HOME,
  UPDATE_PROSPECT_VEHICLE,
  UPDATE_PROSPECT_VIOLATION,
  GET_PROSPECT_DETAILS_EXPORT,
} from "./actionTypes"
import {
  getProspectsSuccess,
  getProspectsError,
  getProspectByIdSuccess,
  getProspectByIdError,
  updateProspectDetailsSuccess,
  updateProspectDetailsError,
  addProspectHomeSuccess,
  addProspectHomeError,
  addProspectViolationSuccess,
  addProspectViolationError,
  addProspectRefundSuccess,
  deleteProspectRefundSuccess,
  deleteProspectRefundError,
  updateProspectSuccess,
  updateProspectError,
  getConsentInformationByIdSuccess,
  getConsentInformationByIdError,
  getProspectDetailReportSuccess,
  getProspectDetailReportError,
} from "./actions"

import * as PROSPECT_CUSTOMIZE_COLUMNS from "./prospectsCustomizeColumnsActionsTypes";

import { fetchCSVLeadDetail, genericDeleteRequest, genericGetRequest, genericGetRequest_2, genericPostRequest, genericPutRequest } from "../../helpers/sf_backend_helper"
import { addProspectVehicleError, addProspectVehicleSuccess, deleteProspectVehicleError, deleteProspectVehicleSuccess, updateProspectVehicleError, updateProspectVehicleSuccess } from "./prospects_vehicles_actions"
import { addProspectBusinessEntityError, addProspectBusinessEntitySuccess, deleteProspectBusinessEntityError, deleteProspectBusinessEntitySuccess, updateProspectBusinessEntityError, updateProspectBusinessEntitySuccess } from "./prospects_business_entity_actions"
import { addProspectApplicantError, addProspectApplicantSuccess, deleteProspectApplicantError, deleteProspectApplicantSuccess, updateProspectApplicantError, updateProspectApplicantSuccess } from "./prospects_applicants_actions"
import { deleteProspectHomeError, deleteProspectHomeSuccess, updateProspectHomeError, updateProspectHomeSuccess } from "./prospects_homes_actions"
import { deleteProspectViolationError, deleteProspectViolationSuccess, updateProspectViolationError, updateProspectViolationSuccess } from "./prospects_violations_actions"
import { getProspectRefundReasonsError, getProspectRefundReasonsSuccess } from "./prospects_refund_reasons_actions"
import { getProspectStickyColumnsError, getProspectStickyColumnsSuccess, updateProspectStickyColumnsError, updateProspectStickyColumnsSuccess } from "./prospects_customize_columns";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert"

function* onGetProspects(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/prospects`; //Check endpoint
    const req_body = { ...action?.payload?.queryParams || "" }
    const req_headers = {
      Authorization: user.token,
      'account-id': user.account_id,
    }
    const response = yield call(genericGetRequest_2, URL, req_body, req_headers)
    yield put(getProspectsSuccess(response, { requestId: action.payload?.requestId, appendResults: action.payload?.appendResults }))
  } catch (error) {
    yield put(getProspectsError(error, { requestId: action.payload?.requestId }))
  }
}

// Fetch All Campaign By Id
function* onGetProspectById(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/leads/${action.payload.id}`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getProspectByIdSuccess(response))
  } catch (error) {
    yield put(getProspectByIdError(error))
  }
}

function* onUpdateProspect(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/leads/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateProspectSuccess(response))
  } catch (error) {
    yield put(updateProspectError(error))
  }
}

function* onUpdateProspectDetails(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_details/${lead?.payload?.lead_details?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateProspectDetailsSuccess(response))
  } catch (error) {
    yield put(updateProspectDetailsError(error))
  }
}

function* onAddProspectVehicle(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_vehicles`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addProspectVehicleSuccess(response))
  } catch (error) {
    yield put(addProspectVehicleError(error))
  }
}

function* onAddProspectHome(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_homes`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addProspectHomeSuccess(response))
  } catch (error) {
    yield put(addProspectHomeError(error))
  }
}

function* onAddProspectBusinessEntity(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_business_entities`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addProspectBusinessEntitySuccess(response))
  } catch (error) {
    yield put(addProspectBusinessEntityError(error))
  }
}

function* onAddProspectViolation(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_violations`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addProspectViolationSuccess(response))
  } catch (error) {
    yield put(addProspectViolationError(error))
  }
}

function* onAddProspectApplicant(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_applicants`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addProspectApplicantSuccess(response))
  } catch (error) {
    yield put(addProspectApplicantError(error))
  }
}


function* onAddProspectRefund(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_refunds`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(addProspectRefundSuccess(response))
  } catch (error) {
    yield put(addProspectRefundSuccess(error))
  }
}

function* onUpdateProspectVehicle(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_vehicles/${lead?.payload?.lead_vehicle?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateProspectVehicleSuccess(response))
  } catch (error) {
    yield put(updateProspectVehicleError(error))
  }
}

function* onUpdateProspectApplicant(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_applicants/${lead?.payload?.lead_applicant?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateProspectApplicantSuccess(response))
  } catch (error) {
    yield put(updateProspectApplicantError(error))
  }
}

function* onUpdateProspectHome(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_homes/${lead?.payload?.lead_home?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateProspectHomeSuccess(response))
  } catch (error) {
    yield put(updateProspectHomeError(error))
  }
}

function* onUpdateProspectViolation(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_violations/${lead?.payload?.lead_violation?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateProspectViolationSuccess(response))
  } catch (error) {
    yield put(updateProspectViolationError(error))
  }
}

function* onUpdateProspectBusinessEntity(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_business_entities/${lead?.payload?.lead_business_entity?.id}`,
      {
        body: JSON.stringify({
          ...lead.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateProspectBusinessEntitySuccess(response))
  } catch (error) {
    yield put(updateProspectBusinessEntityError(error))
  }
}

function* onDeleteProspectVehicle(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_vehicles/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteProspectVehicleSuccess(response))
  } catch (error) {
    yield put(deleteProspectVehicleError(error))
  }

}

function* onDeleteProspectHome(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_homes/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteProspectHomeSuccess(response))
  } catch (error) {
    yield put(deleteProspectHomeError(error))
  }
}

function* onDeleteProspectBusinessEntity(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_business_entities/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteProspectBusinessEntitySuccess(response))
  } catch (error) {
    yield put(deleteProspectBusinessEntityError(error))
  }
}

function* onDeleteProspectViolation(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_violations/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteProspectViolationSuccess(response))
  } catch (error) {
    yield put(deleteProspectViolationError(error))
  }
}

function* onDeleteProspectRefund(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_refunds/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteProspectRefundSuccess(response))
  } catch (error) {
    yield put(deleteProspectRefundError(error))
  }
}

function* onDeleteProspectApplicant(lead) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_applicants/${lead?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteProspectApplicantSuccess(response))
  } catch (error) {
    yield put(deleteProspectApplicantError(error))
  }
}

// Fetch All Lead Refund Reasons
function* onGetProspectRefundReasons(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_refund_reasons`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getProspectRefundReasonsSuccess(response))
  } catch (error) {
    yield put(getProspectRefundReasonsError(error))
  }
}

function* onGetProspectStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/prospects_customize_columns`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getProspectStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getProspectStickyColumnsError(error))
  }
}

function* onUpdateProspectStickyColumns({payload}) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/prospects_customize_columns/${payload?.customize_columns?.id}`,
      {
        body: JSON.stringify({user_column_preference_prospect: {...payload.customize_columns}}),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        } 
      }
    )
    yield put(updateProspectStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateProspectStickyColumnsError(error))
  }
}

function* onGetConsentInformationById({payload}) {
  try {
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.CONSENT_BACKEND_URL}/public/getSessionDetails/${payload}`,
      {},
      {
        'Content-Type': 'application/json'
      }
    )
    yield put(getConsentInformationByIdSuccess(response))
  } catch (error) {
    yield put(getConsentInformationByIdError(error))
  }
}

function* onProspectDetailExport(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let lead_id = action?.payload?.queryParams?.lead_id
    const response = yield call(
      fetchCSVLeadDetail,
      `${AppConfiguration.BACKEND_URL}/api/v1/prospect_detail_export/${lead_id}`,
      action.payload?.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id

      },
      action?.filename
    )
    const res = { status: response.status };
    if(response.status === 200)
    {
      yield put(getProspectDetailReportSuccess(res, action?.filename))
    } else {
      ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: "Something went wrong!" })
      yield put(getProspectDetailReportError(res))
    }
  } catch (error) {
    yield put(getProspectDetailReportError(error))
  }
}

function* ProspectsSaga() {
  yield takeLatest(GET_PROSPECTS, onGetProspects)
  yield takeEvery(GET_PROSPECT_BY_ID, onGetProspectById)
  yield takeEvery(UPDATE_PROSPECT_DETAILS, onUpdateProspectDetails)
  yield takeEvery(UPDATE_PROSPECT, onUpdateProspect)
  yield takeEvery(ADD_PROSPECT_VEHICLE, onAddProspectVehicle)
  yield takeEvery(UPDATE_PROSPECT_VEHICLE, onUpdateProspectVehicle)
  yield takeEvery(DELETE_PROSPECT_VEHICLE, onDeleteProspectVehicle)
  yield takeEvery(ADD_PROSPECT_HOME, onAddProspectHome)
  yield takeEvery(UPDATE_PROSPECT_HOME, onUpdateProspectHome)
  yield takeEvery(DELETE_PROSPECT_HOME, onDeleteProspectHome)
  yield takeEvery(ADD_PROSPECT_BUSINESS_ENTITY, onAddProspectBusinessEntity)
  yield takeEvery(UPDATE_PROSPECT_BUSINESS_ENTITY, onUpdateProspectBusinessEntity)
  yield takeEvery(DELETE_PROSPECT_BUSINESS_ENTITY, onDeleteProspectBusinessEntity)
  yield takeEvery(ADD_PROSPECT_VIOLATION, onAddProspectViolation)
  yield takeEvery(UPDATE_PROSPECT_VIOLATION, onUpdateProspectViolation)
  yield takeEvery(DELETE_PROSPECT_VIOLATION, onDeleteProspectViolation)
  yield takeEvery(ADD_PROSPECT_APPLICANT, onAddProspectApplicant)
  yield takeEvery(UPDATE_PROSPECT_APPLICANT, onUpdateProspectApplicant)
  yield takeEvery(DELETE_PROSPECT_APPLICANT, onDeleteProspectApplicant)
  yield takeEvery(ADD_PROSPECT_REFUND, onAddProspectRefund)
  yield takeEvery(DELETE_PROSPECT_REFUND, onDeleteProspectRefund)
  yield takeEvery(GET_PROSPECT_REFUND_REASONS, onGetProspectRefundReasons)
  yield takeEvery(PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_STICKY_COLUMNS, onGetProspectStickyColumns)
  yield takeEvery(PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_STICKY_COLUMNS, onUpdateProspectStickyColumns)
  yield takeEvery(GET_CONSENT_INFORMATION_BY_ID, onGetConsentInformationById)
  yield takeEvery(GET_PROSPECT_DETAILS_EXPORT, onProspectDetailExport)
}

export default ProspectsSaga;
